// extracted by mini-css-extract-plugin
export default {"infoText":"EditInfo__infoText____FLis"};